/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";
import "./container.scss";

interface Props {
  children: React.ReactNode;
  isRaw?: boolean;
}

const Container: React.FC<Props> = (props: Props) => {
  const { children } = props;
  return (
    <div className={`container${props.isRaw ? " isRaw" : ""}`} >
      {children}
    </div >
  )
}

export default Container;